<div class="side-bar" data-sidebar-container>
  <div class="side-bar__signing-details" data-sidebar-signing-details>
    <app-signing-details-card></app-signing-details-card>
  </div>

  <div class="side-bar__dynamic-content">
    @if (dynamicContent === SideBarContentEnum.SigningsMonthly) {
      <app-signings-monthly-card
      ></app-signings-monthly-card>
    }

    @if (dynamicContent === SideBarContentEnum.ParticipantList) {
      <app-participant-list
        class="side-bar__participant-list"
        >
      </app-participant-list>
    }
  </div>
</div>
